import { combineEpics } from 'redux-observable';

import { findOrganisationInvoiceEpic }        from './FindOrganisationInvoice/FindOrganisationInvoiceEpic';
import { findOrganisationInvoicesEpic }       from './FindOrganisationInvoices/FindOrganisationInvoicesEpic';
import { sendOrganisationInvoicePdfEpic }     from './SendOrganisationInvoicePdf/SendOrganisationInvoicePdfEpic';
import { downloadOrganisationInvoicePdfEpic } from './DownloadOrganisationInvoicePdf/DownloadOrganisationInvoicePdfEpic';


export const organisationInvoiceEpics = combineEpics(
  findOrganisationInvoiceEpic,
  findOrganisationInvoicesEpic,
  sendOrganisationInvoicePdfEpic,
  downloadOrganisationInvoicePdfEpic,
);
